var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polygon2, _rect, _path7, _path8, _path9, _polygon3, _rect2, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewiumlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 938.81 417.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10cda7;}.cls-2{fill:#f7cc1b;}.cls-3{fill:#7855f9;}.cls-4{fill:#fd486b;}.cls-5{fill:#182547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.68 58.11 367.68 83.12 320.25 83.12 472.45 284.92 625.88 83.45 578.11 83.52 600.27 58.11 676.49 58.11 472.86 323.24 273.49 58.11 342.68 58.11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.58,423.91,592,514.11l-17.69,23.28a55,55,0,0,1-18.53-41.22V447.88a55,55,0,0,1,20-42.45h0a55.19,55.19,0,0,1,24.75-11.68,39.33,39.33,0,1,1,20.84,0,55.13,55.13,0,0,1,39.24,30.17Z",
    transform: "translate(-64.51 -316.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M520.6,447.88v48.29a55,55,0,0,1-16.15,39c-1.16,1.16-2.36,2.27-3.63,3.32l-19.1-25.34L415.27,425a55.37,55.37,0,0,1,23.58-25.43A54.8,54.8,0,0,1,455,393.74a39.33,39.33,0,1,1,20.85,0,55.13,55.13,0,0,1,44.71,54.14Z",
    transform: "translate(-64.51 -316.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M592,483v31.09l-17.69,23.28L537,586.45l-36.19-48-19.1-25.34V483a55.17,55.17,0,0,1,33.37-50.67,39.27,39.27,0,0,1-17.39-29.2c-.11-1.17-.16-2.35-.16-3.55a39.33,39.33,0,0,1,78.65,0,37.17,37.17,0,0,1-.44,5.82h0a39.22,39.22,0,0,1-17.12,26.92A55.15,55.15,0,0,1,592,483Z",
    transform: "translate(-64.51 -316.49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.5,682.27V734h-13V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M171.56,682.27V734H153.9l-39-40.56V734h-13V682.27h17.66l39.05,40.56V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.8,682.27v10.27H233.3V734h-13V692.54H192.38V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "230.11 396.72 266.51 396.72 266.51 386.46 217.11 386.46 217.11 417.47 277.42 417.47 277.42 407.21 230.11 407.21 230.11 396.72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.11,
    y: 365.78,
    width: 60.31,
    height: 10.27
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.62,682.27a14.83,14.83,0,0,1,5.17.9,12.87,12.87,0,0,1,4.23,2.51,11.7,11.7,0,0,1,2.84,3.88,11.82,11.82,0,0,1,1,5v7.39a9.47,9.47,0,0,1-.5,2.95,10.55,10.55,0,0,1-1.4,2.76,9.41,9.41,0,0,1-2.12,2.15,6.58,6.58,0,0,1-2.66,1.19,7.86,7.86,0,0,1,4.85,2.87,8.18,8.18,0,0,1,1.83,5.24V734H421V719.89a3.89,3.89,0,0,0-1.15-2.66,3.65,3.65,0,0,0-2.66-1.07H391.54L381.2,705.89h35.9a4.31,4.31,0,0,0,2.73-.9,3,3,0,0,0,1.15-2.47V696a3.09,3.09,0,0,0-1.12-2.51,4.06,4.06,0,0,0-2.69-.93H378.26V734h-13V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M529.68,682.27,499.59,734H482.15l-30.08-51.69h14.28l24.56,42.5,24.48-42.5Z",
    transform: "translate(-64.51 -316.49)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.78,682.27V734h-13V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "535.67 396.72 572.07 396.72 572.07 386.46 522.68 386.46 522.68 417.47 582.99 417.47 582.99 407.21 535.67 407.21 535.67 396.72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.68,
    y: 365.78,
    width: 60.31,
    height: 10.27
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M771.77,682.27l-22,51.69H733.08l-13.65-35-13.49,35H689.21l-22-51.69H681.6l16,40.42L713,682.27H726l15.36,40.42,16-40.42Z",
    transform: "translate(-64.51 -316.49)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M805.59,682.27V734h-13V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M898.35,682.27v35.9a15.33,15.33,0,0,1-1.25,6.17,16.24,16.24,0,0,1-3.42,5,15.86,15.86,0,0,1-11.2,4.59h-37a15.36,15.36,0,0,1-6.11-1.22,15.83,15.83,0,0,1-5-3.37,16.21,16.21,0,0,1-3.41-5,15.17,15.17,0,0,1-1.26-6.17v-35.9h13V719A4.61,4.61,0,0,0,844,722.3a4.32,4.32,0,0,0,3.26,1.4h33.46a4.45,4.45,0,0,0,3.3-1.4,4.56,4.56,0,0,0,1.37-3.27V682.27Z",
    transform: "translate(-64.51 -316.49)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1003.32,682.27V734h-13V698l-23.26,36h-8.47L935.4,698v36h-13V682.27h16.3l24.2,38.19,25.34-38.19Z",
    transform: "translate(-64.51 -316.49)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewiumlogo);
export default __webpack_public_path__ + "static/media/Interviewiumlogo.92e1c23dad41efac6bc1601a7edc7dd1.svg";
export { ForwardRef as ReactComponent };